import React from "react";
import LandingComponent from "../../components/LandingComponent/landingComponent";

const LandingPage = () => {
  return (
    <div className="container-md customMargin">
      <LandingComponent />
    </div>
  );
};

export default LandingPage;
